export const sg3MonthlyChecklistLicenseeFormMap = {
    "Trust Account Review" : [
        {
            id: "TrustAccountReview-Q1",
            question:
                "Have all cancelled original receipts been attached to the duplicate receipt and retained on file?",
        },
        {
            id: "TrustAccountReview-Q2",
            question: "Have any original receipts not issued been retained on file?",
        },
        {
            id: "TrustAccountReview-Q3",
            question: "Did the trust account become overdrawn during the month?",
        },
    ],

    "Trust Account Reconciliation" : [
        {
            id: "TrustAccountReconciliation-Q1",
            question:
                "Are the three balances shown on the bank reconciliation report (ie bank reconciliation statement, cash book balance and the ledger balance) are identical?",
        },
        {
            id: "TrustAccountReconciliation-Q2",
            question:
                "Is the bank balance for the period the same as the bank balance shown on the bank reconciliation report?",
        },
        {
            id: "TrustAccountReconciliation-Q3",
            question: "Are there any outstanding deposits on the bank reconciliation?",
        },
        {
            id: "TrustAccountReconciliation-Q4",
            question: "If yes, Are they genuine deposits?",
        },
        {
            id: "TrustAccountReconciliation-Q5",
            question:
                "Have any unpresented cheques from last month been presented? (You will need to confirm this by locating them on the bank statements)",
        },
        {
            id: "TrustAccountReconciliation-Q6",
            question: "Is there any adjustments shown on the bank reconciliation?",
        },
        {
            id: "TrustAccountReconciliation-Q7",
            question: "If yes, Has a reason for the adjustments been documented on the Adjustments Report?",
        },
    ],

    "EFT Report": [
        {
            id: "EFTReport-Q1",
            question: "Does the EFT amount match the amount imported into the bank for disbursement?",
        },
        {
            id: "EFTReport-Q2",
            question: "Has the EFT report been signed?",
        },
    ],
};